import { retrieveErrorFromApi } from '../../../../helper'
import { setRestaurantTablesNotifications, setRestaurantTablesNotificationsLength, setRestaurantTablesWaiterNotificationsCount } from '../../../action/restaurant'
import { setAppErrors } from '../../../action/system'
import getNotifications from '../../../axios/posNotification/notifications'
import updateNotificationStatus from '../../../axios/posNotification/notifications/put'

export const fetchNotificationsThunk = (shouldCountWaiterRequests) => dispatch => {
	return getNotifications()
		.then(res => {
			dispatch(setRestaurantTablesNotifications(res.data))
			dispatch(setRestaurantTablesNotificationsLength(res.data?.length))
			if (shouldCountWaiterRequests) {
				const waiterNotifications = res.data?.filter(item => item.type === 'GUEST_ASK_WAITER')?.length
				dispatch(setRestaurantTablesWaiterNotificationsCount(waiterNotifications))
			}
		}).catch(error => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}

export const updateNotificationStatusThunk = (id, status) => (dispatch) => {
	return updateNotificationStatus(id, status)
		.then((res) => {
			dispatch(fetchNotificationsThunk())
		}).catch((error) => {
			dispatch(setAppErrors(retrieveErrorFromApi(error)))
		})
}
